import React from 'react';
import { Stack, Typography, type StackProps } from '@mui/material';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import { useTranslation } from 'react-i18next';

export type TutorSessionTypeHeadingVariant = 'types' | 'type';

export interface TutorSessionTypeHeadingProps {
  variant?: TutorSessionTypeHeadingVariant;
  sx?: StackProps['sx'];
}

const TutorSessionTypeHeading: React.FC<TutorSessionTypeHeadingProps> = ({ variant = 'types', sx }) => {
  const { t } = useTranslation();
  const label =
    variant === 'types'
      ? t('tutorSearch.sessionTypes', 'Session types')
      : t('tutor.sessionType.label', 'Session type');

  return (
    <Stack direction="row" spacing={0.55} alignItems="center" sx={sx}>
      <ViewModuleOutlinedIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
      <Typography variant="overline" color="text.secondary" lineHeight={1.2}>
        {label}
      </Typography>
    </Stack>
  );
};

export default TutorSessionTypeHeading;
